module.exports = __webpack_public_path__ + "static/media/icon_boleto.bac05777.svg";